import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    frameId: String,
    listUrl: String
  }

  connect() {
    this.onFrameLoad = this.onFrameLoad.bind(this)
    this.onTabShown = this.onTabShown.bind(this)
    this.onTreatmentsTabClick = this.onTreatmentsTabClick.bind(this)

    this.treatmentsTab = this.element.querySelector('[id$="-tab-treatments-btn"]')
    this.treatmentsTab?.addEventListener("click", this.onTreatmentsTabClick)
    this.element.addEventListener("shown.bs.tab", this.onTabShown)
    document.addEventListener("turbo:frame-load", this.onFrameLoad)

    const frame = this.frameElement
    if (frame) {
      this.syncFrameViewState(frame)
      this.decoratePaginationLinks(frame)
    }
  }

  disconnect() {
    this.treatmentsTab?.removeEventListener("click", this.onTreatmentsTabClick)
    this.element.removeEventListener("shown.bs.tab", this.onTabShown)
    document.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  get frameElement() {
    return document.getElementById(this.frameIdValue)
  }

  onFrameLoad(event) {
    const frame = event.target
    if (frame.id !== this.frameIdValue) return

    this.syncFrameViewState(frame)
    this.decoratePaginationLinks(frame)
  }

  syncFrameViewState(frame) {
    const marker = frame.querySelector("[data-treatment-history-view]")
    if (marker) {
      frame.dataset.historyView = marker.dataset.treatmentHistoryView
    }
  }

  isDetailView(frame = this.frameElement) {
    if (!frame) return false
    return frame.querySelector('[data-treatment-history-view="detail"]') !== null
  }

  returnToListIfDetail() {
    this.returnToListIfNeeded()
  }

  onTreatmentsTabClick() {
    this.returnToListIfNeeded()
  }

  onTabShown(event) {
    if (!event.target?.matches?.('[id$="-tab-treatments-btn"]')) return
    this.returnToListIfNeeded()
  }

  returnToListIfNeeded() {
    const frame = this.frameElement
    if (!frame || !this.isDetailView(frame)) return
    this.loadList()
  }

  loadList() {
    if (!this.listUrlValue || !this.frameIdValue) return
    Turbo.visit(this.listUrlValue, { frame: this.frameIdValue })
  }

  decoratePaginationLinks(frame) {
    if (!frame) return

    frame.querySelectorAll(".customer-treatment-history-pagination a").forEach((link) => {
      link.dataset.turboFrame = frame.id
    })
  }
}
